import { render, staticRenderFns } from "./WsOrgsFilter.vue?vue&type=template&id=0447a258"
import script from "./WsOrgsFilter.vue?vue&type=script&lang=js"
export * from "./WsOrgsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports